<div class="home-customizer-container">
    <div>
        <div id="customizer_Name" 
            [innerHTML]="customizer.innerHTML | safe: 'html'"></div>
    </div>
</div>
